import React from "react";
import moment from "moment";

import { Line } from "react-chartjs-2";

import ModulePanel from "../../ModulePanel";

const SecondChart = ({ dates_data })=>{

    const data = {
        labels: [],
        datasets: [
            {
                label: '',
                fill: false,
                lineTension: 0.1,
                backgroundColor: 'rgba(75,192,192,0.4)',
                borderColor: 'rgba(75,192,192,1)',
                borderCapStyle: 'butt',
                borderDash: [],
                borderDashOffset: 0.0,
                borderJoinStyle: 'miter',
                pointBorderColor: 'rgba(75,192,192,1)',
                pointBackgroundColor: '#fff',
                pointBorderWidth: 1,
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                pointHoverBorderColor: 'rgba(220,220,220,1)',
                pointHoverBorderWidth: 2,
                pointRadius: 1,
                pointHitRadius: 10,
                data: []
            }
        ]
    };

    let 
        firstDate = 0,
        lastDate = 0,
        count = 0;

    for (let day in dates_data){
        if (firstDate === 0){
            data.labels.push(moment(day, "YYYY-MM-DD").add(-1, "days").format("YYYY-MM-DD"));        
            data.datasets[0].data.push(0);
            firstDate = 1;
        }
        count += dates_data[day];
        data.labels.push(day);
        data.datasets[0].data.push(dates_data[day]);
        lastDate = day;
    }

    data.labels.push(moment(lastDate, "YYYY-MM-DD").add(1, "days").format("YYYY-MM-DD"));
    data.datasets[0].data.push(0);

    return (
        <ModulePanel title={[`Retroalimentación recibida (${count})`]}>
            <Line data={data} options={{legend: { display: false}}}/>
        </ModulePanel>
    )
}

export default SecondChart;